import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref, watch } from "vue"
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue"
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue"
import { useRoute, useRouter } from "vue-router"
import { chatsStore } from "@/store/chats"
import { rootStore } from "@/store/index"
import { VersionApi } from "@/ api/VersionApi"


export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderLogo',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const root = rootStore()

const serverVersion = ref('')

const onLogoClick = () => {
	chatsStore().setMode('list')
	chatsStore().setOpenedChat(null)
	if (route.path === '/main' && route.query.page === 'chat' && route.query.mode === 'list') return
	router.push({
		path: '/main',
		query: {
			page: 'chat',
			mode: 'list'
		}
	})
}

const fetchServerVersion = async () => {
	const versions = await VersionApi.getVersions()
	const version = versions?.ServerVersion
	if (!version) {
		return
	}

	serverVersion.value = [version.Global, version.Component, version.Update, version.Fix].join('.')
}

onMounted(() => {
	if (root.globalJWT) {
		fetchServerVersion()
		return
	}
	const unwatch = watch(() => root.globalJWT, (token) => {
		if (token) {
			fetchServerVersion()
			unwatch()
		}
	})
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "header-logo",
    onClick: onLogoClick
  }, [
    _createVNode(AppTooltip, {
      class: "header-logo__tooltip",
      text: _ctx.$t('server_version', { version: serverVersion.value }),
      disabled: !serverVersion.value
    }, {
      activator: _withCtx(() => [
        _createVNode(AppIcon, {
          name: "logo",
          width: "123px",
          height: "24px"
        })
      ]),
      _: 1
    }, 8, ["text", "disabled"])
  ]))
}
}

})